import React from "react";
import Modal1 from "../../../../../components/DIsplay/Modal/Modal1";
import PaymentMethod from "../../../../../components/flight/PaymentMethod";

function ManageOrderPaymentModal({ booking, modal, setModal }) {
  return (
    <div>
      <Modal1
        open={modal.payment}
        setOpen={(modalState) =>
          setModal((prev) => ({ ...prev, payment: modalState }))
        }
      >
        <PaymentMethod
          callback={() => {
            setTimeout(() => {
              window.location.reload();
            }, 300);
          }}
          flightBookingId={booking?._id}
          hide={["booklater"]}
          expand
        />
      </Modal1>
    </div>
  );
}

export default ManageOrderPaymentModal;
